import { useCallback, useState } from 'react';
import { dataHooks } from '../../../utils/datahooks';
import { useCollapseItems } from '../../../utils/use-on-rule-group-toggle';
import { useUnsavedChangesHandlers } from '../../../utils/use-unsaved-changes-handlers';
export const useToggleFixer = ruleResult => {
  var _footerLabels$buttonT;
  const {
    onApply,
    onCancel,
    footerLabels,
    toggleLabel,
    onSelect
  } = ruleResult.fixerProps;
  const {
    description,
    tips
  } = ruleResult;
  const unsavedChangesHandlers = useUnsavedChangesHandlers();
  const {
    collapseRule
  } = useCollapseItems();
  const [toggleChecked, setToggleChecked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const onApplyClick = useCallback(async checked => {
    try {
      setShowLoader(true);
      await onApply(checked);
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } catch (e) {
      console.error(e);
    }
    setShowLoader(false);
    collapseRule();
  }, [collapseRule, onApply, unsavedChangesHandlers]);
  const onCancelClick = useCallback(() => {
    collapseRule();
    onCancel == null || onCancel();
    unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
  }, [collapseRule, onCancel, unsavedChangesHandlers]);
  const onChange = useCallback(() => {
    setToggleChecked(!toggleChecked);
    onSelect == null || onSelect(!toggleChecked);
  }, [onSelect, toggleChecked]);
  return {
    checkedValue: toggleChecked,
    description,
    onChange,
    ruleFooterProps: {
      dataHook: dataHooks.footerToggleFixer(ruleResult.dataHook),
      dismissButtonProps: {
        label: footerLabels.dismiss,
        onClick: onCancelClick,
        type: ((_footerLabels$buttonT = footerLabels.buttonTypes) == null ? void 0 : _footerLabels$buttonT.dismiss) ?? 'textButton'
      },
      submitButtonProps: {
        disabled: toggleChecked === false,
        label: footerLabels.submit,
        onClick: () => onApplyClick(toggleChecked),
        showLoader
      }
    },
    tips,
    toggleLabel
  };
};
//# sourceMappingURL=use-toggle-fixer.js.map